import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import ClientLogoSlider from "./ClientLogoSlider";
import TabImage2 from "./TabImage2";
import { Link } from "react-router-dom";

function AccelAlert() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const features = [
    {
      title: "Smart HSE Monitoring",
      description: "(Air, Water, Fire, Noise, Workplace Safety)",
      img: assets.cc1,
    },
    {
      title: "Multi-Channel Notifications",
      description: "(SMS, Email, App, Radio, Siren)",
      img: assets.cc2,
    },
    {
      title: "Real-Time Alerts & Threshold Triggers",
      description: "",
      img: assets.cc3,
    },
    {
      title: "Satellite, Sensor & IoT Integration",
      description: "",
      img: assets.cc4,
    },
    {
      title: "GIS Mapping & Geofenced Risk Zones",
      description: "",
      img: assets.cc5,
    },
    {
      title: "Emergency Response Workflows & Escalation Protocols",
      description: "",
      img: assets.cc6,
    },
    {
      title: "Regulatory Compliance Reporting",
      description: "(OSHA, ISO, NDMA, SEBI)",
      img: assets.cc7,
    },
    {
      title: "HSE Dashboards & Predictive Analytics",
      description: "",
      img: assets.cc8,
    },
  ];

  const designed = [
    {
      title: "Manufacturing & Industrial Facilities",
      img: assets.df1,
    },
    {
      title: "Smart Cities & Disaster Management Authorities",
      img: assets.df2,
    },
    {
      title: "Energy, Mining, and Utilities",
      img: assets.df3,
    },
    {
      title: "Ports, Airports, & Transport Infrastructure",
      img: assets.df4,
    },
    {
      title: "Local Governments & First Responders",
      img: assets.df5,
    },
  ];

  const regulatorycompliance = [
    {
      title: "OSHA",
      description: "Occupational Health & Safety Standards",
    },
    {
      title: "SEBI BRSR",
      description: "Safety disclosures for listed entities",
    },
    {
      title: "NDMA / SDMA",
      description: "India’s disaster management mandates",
    },
    {
      title: "ISO",
      description: "Occupational health & safety management",
    },
  ];

  return (
    <div>
      <div className="inner-new-section-1 accelalert-bg-1">
        <div className="wrapper height-inherit">
          <div className="bottom-sec-1 max-width-500 padding-bottom-1">
            {/* <img
              src={assets.AccelALERTLogo2}
              alt="AccelALERT"
              data-aos="fade-down"
            /> */}
            <h1 className="white-color" data-aos="zoom-in">
              AccelALERT<sup>™</sup> – HSE Intelligence & Disaster Readiness
              Platform
            </h1>
            <p data-aos="zoom-in">
              Empowering organizations and communities to predict, prepare, and
              protect against health, safety, and environmental threats.
            </p>
            <div className="text-left">
              <Link
                to="/company/contact#Book-Meeting"
                className="button-1 green-bg"
                data-aos="fade-up"
              >
                Request a Demo
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 accelalert-bg-2">
        <div className="wrapper height-inherit">
          <div className="flagship-heading">
            <h2 data-aos="fade-up">
              Real-Time Situational Awareness, Risk Monitoring & Emergency
              Response
            </h2>
          </div>

          <div className="section-2-2">
            <p data-aos="fade-down">
              AccelALERT™ is a powerful platform designed to detect early
              warning signals across environmental, health, and workplace safety
              systems. From manufacturing plants to city municipalities and
              emergency services, AccelALERT™ helps minimize risk, coordinate
              response, and ensure compliance through intelligent alerting and
              response workflows.
            </p>
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 accelalert-bg-3">
        <div className="wrapper">
          <h2 className="text-center blue-color">Core Capabilities</h2>
          <div className="Core-Capabilities-wrap">
            {/* <div className="cc-1">
              <div className="cc-1-1">
                <img src={assets.cc1} alt="" />
              </div>
              <div className="cc-1-2">
                <h6>Smart HSE Monitoring</h6>
                <p>(Air, Water, Fire, Noise, Workplace Safety)</p>
              </div>
            </div> */}
            <div className="Core-Capabilities-wrap">
              {features.map((feature, index) => (
                <div className="cc-1" key={index}>
                  <div className="cc-1-1">
                    <img src={feature.img} alt="" data-aos="zoom-in" />
                  </div>
                  <div className="cc-1-2" data-aos="zoom-in">
                    <h6>{feature.title}</h6>
                    {feature.description && <p>{feature.description}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="flagship-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="blue-color">Designed for…</h2>
          </div>

          <div className="Designedfor-wrap ">
            {designed.map((designed, index) => (
              <div className="df-1" key={index}>
                <div className="df-1-1" data-aos="zoom-in">
                  <img src={designed.img} alt="" />
                </div>
                <div className="df-1-2">
                  <p>{designed.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 accelalert-bg-3a">
        <div className="wrapper height-inherit">
          <h2>Situational Intelligence in Action</h2>

          <div className="section-2-2 flex-column">
            <div
              className="SituationalIntelligence flex-end"
              data-aos="zoom-in"
            >
              <div className="black-bg-2">
                <p>
                  “With AccelALERT™, we detected a steam pressure anomaly in
                  real time and prevented a major equipment failure. It improved
                  our incident response time by over 60% and safeguarded both
                  our workforce and production uptime.”
                </p>
                <i>— Sagran Govindasamy, EHS Lead, Tongaat Hulett</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 accelalert-bg-4">
        <div className="wrapper height-inherit">
          <div className="flagship-heading">
            <h2>Integrates with Sensors, Satellites, and Systems</h2>
          </div>

          <div className="section-2-2">
            <div className="section-4-2-1" data-aos="zoom-in-down">
              <img src={assets.IntegratesSensors1} alt="" />
              <span>Weather & Air Quality APIs</span>
              <i>(AQI, IMD, NASA, OpenWeather)</i>
            </div>
            <div className="section-4-2-1" data-aos="zoom-in-down">
              <img src={assets.IntegratesSensors2} alt="" />
              <span>IoT Devices</span>
              <i>(smoke, gas, temperature, vibration)</i>
            </div>
            <div className="section-4-2-1" data-aos="zoom-in-down">
              <img src={assets.IntegratesSensors3} alt="" />
              <span>Surveillance Cameras & Drones</span>
            </div>
            <div className="section-4-2-1" data-aos="zoom-in-down">
              <img src={assets.IntegratesSensors4} alt="" />
              <span>Emergency Notification Systems</span>
            </div>
            <div className="section-4-2-1" data-aos="zoom-in-down">
              <img src={assets.IntegratesSensors5} alt="" />
              <span>Enterprise Risk Management Platforms</span>
            </div>
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 accelalert-bg-5">
        <div className="wrapper height-inherit">
          <div className="bioforge-align-right ">
            <div className="bioforge-section-2-1">
              <h2 className="blue-color">HSE Intelligence That Scales</h2>
              <div className="building-list black-color">
                <ul>
                  <li>No-code alert rules & escalation workflows</li>
                  <li>Role-based access & control center UI</li>
                  <li>Historical incident logs & predictive analytics</li>
                  <li>Deployment at facility, regional, or national levels</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-section-1 green-bg-4">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="blue-color">Why Choose AccelALERT™?</h2>
          </div>
          <div className="text-center">
            <img
              src={assets.AccelALERt2}
              alt="AccelALERt2"
              className="img-w-1"
              data-aos="zoom-in"
            />
          </div>
        </div>
      </div>

      <div className="flagship-bg height-inherit-1">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="blue-color">Regulatory Compliance Made Easy</h2>
            <p>Compliant with:</p>
          </div>

          <div className="RegulatoryCompliance-wrap ">
            {regulatorycompliance.map((regulatorycompliance, index) => (
              <div className="rc-1" key={index}>
                <h4>{regulatorycompliance.title}</h4>
                {regulatorycompliance.description && (
                  <p>{regulatorycompliance.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 accelalert-bg-6">
        <div className="wrapper height-inherit">
          <div className="text-center">
            <h2>AccelALERT™ in the Field</h2>
          </div>
          <TabImage2 />
        </div>
      </div>

      <div className="ClimateFutureTogether-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="blue-color">
              Let’s Build a Safer, Smarter Future Together
            </h2>
            <p>
              Protect people, assets, and the planet with the power of
              data-driven HSE intelligence.
            </p>

            <Link
              to="/company/contact#Book-Meeting"
              className="button-1 blue-bg"
              onClick={scrollToTop}
            >
              Get a Custom Demo
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccelAlert;
